import { render, staticRenderFns } from "./SmokingSavedMoney.vue?vue&type=template&id=4bd6caf1&"
import script from "./SmokingSavedMoney.vue?vue&type=script&lang=js&"
export * from "./SmokingSavedMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bd6caf1')) {
      api.createRecord('4bd6caf1', component.options)
    } else {
      api.reload('4bd6caf1', component.options)
    }
    module.hot.accept("./SmokingSavedMoney.vue?vue&type=template&id=4bd6caf1&", function () {
      api.rerender('4bd6caf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/smoking/SmokingSavedMoney.vue"
export default component.exports